module.exports = __webpack_public_path__ + "static/media/assessment-pause-light.3a84a76b.svg";